import styled from 'styled-components';

export const UiActionContainer = styled.div`
    display: flex;
`;
